import { createValidationSchema, validate } from "@";

export const schema = createValidationSchema({
  reply: validate("req", "reply"),
});

export const defaultValues = {
  id: null,
  reply: null,
  imageFullUrl: "",
  contactUsReplyStatus: 0,
  sendReplyToCustomer: false,
};
